import React, { Component } from 'react';
import logo from '../assets/image/logo.png';
import '../css/PageNotFound.css';

const $ = window.$;

class PageNotFound extends Component {

    componentDidMount() {
        var content = $('.page-content')[0].clientHeight;
        $('.page-content').css('margin-top', (($(window).height() / 2) - ((content + 100) / 2)) + 'px')
    }

    render() {
        return(
            <div className="page-content">
                <img className="page-content-img" src={logo} />
                <div className="page-title-thai">ไม่พบหน้าที่คุณต้องการ</div>
                <div className="page-error-code">URL ผิดพลาด กรุณาลองใหม่อีกครั้ง หากไม่สามารถใช้งานได้กรุณาติดต่อสหกรณ์</div>
                <div className="page-error-contact">
                    <i className="fas fa-phone-volume" />
                    โทรศัพท์ : 0-2537-9140 หรือ 0-2936-0400 ต่อ  13 , 17 , 19 – 20
                </div>
                <div className="page-error-contact">
                    <i className="fas fa-envelope" />
                    อีเมล์ : srusct2555@gmail.com
                </div>
            </div>
        )
    }
}

export default PageNotFound;